<ion-app>
  <ion-menu
    side="start"
    menuId="main-menu"
    contentId="main-content"
    type="overlay"
    *ngIf="isLoggedIn && !isLoginRoute()"
  >
    <ion-header>
      <ion-toolbar>
        <ion-title>Menú</ion-title>
      </ion-toolbar>
    </ion-header>

    <ion-content>
      <ion-list>
        <ion-item lines="none">
          <ion-label>
            <h2>{{ userName }}</h2>
            <p>{{ roleName }}</p>
          </ion-label>
          <!-- NUEVO BOTÓN DE EDITAR PERFIL -->
          <ion-menu-toggle auto-hide="false" slot="end">
            <ion-button fill="clear" color="primary" (click)="editarMiPerfil()">
              <ion-icon slot="icon-only" name="create-outline"></ion-icon>
            </ion-button>
          </ion-menu-toggle>
        </ion-item>
        
      

        <ion-menu-toggle auto-hide="true" *ngFor="let item of menuItems">
          <ion-item [routerLink]="item.url" routerDirection="root" button>
            <ion-icon slot="start" [name]="item.icon"></ion-icon>
            <ion-label>{{ item.title }}</ion-label>
          </ion-item>
        </ion-menu-toggle>

        <ion-item button (click)="logout()">
          <ion-icon slot="start" name="log-out-outline"></ion-icon>
          <ion-label>Cerrar sesión</ion-label>
        </ion-item>
      </ion-list>
    </ion-content>
  </ion-menu>

  <ion-router-outlet id="main-content"></ion-router-outlet>
</ion-app>